import { render } from "./ui-kebab-menu.vue?vue&type=template&id=2c03a54c&scoped=true"
import script from "./ui-kebab-menu.vue?vue&type=script&lang=js"
export * from "./ui-kebab-menu.vue?vue&type=script&lang=js"

import "./ui-kebab-menu.vue?vue&type=style&index=0&id=2c03a54c&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c03a54c"]])

export default __exports__